import styled from 'styled-components';
import { DynamicExteriorImagePreviewStyled } from '../DynamicExteriorImagePreviewStyled';

export const DynamicExteriorImagePreviewOV = styled(DynamicExteriorImagePreviewStyled)`
    img {
        object-fit: unset;
        height: unset;
    }
`;
